import React from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, InnerHeading, LazyImage, MainHeading, SpanStyled, SpanStyledB } from '../../../ui/Elements'
import { ArrowBtnBrown, CEOBg, CEOImg, Sofa, TransformBg } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { ContactButton } from '../../../ui/CustomElements'
import i18n from '../../../Languages/INEXT'
const CeoMessage = () => {
    const { t } = useTranslation();
    
    return (
        <>
            <TransformWapper className='container-fluid common-space transformFluid'>
                <Container>
                    <Row className='transformRow row'>
                        <Col md={12} className="transformColMain">
                            <Box className='transformContent'>
                                <Box className='ceoImg'>
                                    <LazyImage src={CEOImg} />
                                </Box>
                                <InnerHeading className='main-heading mb-1'>
                                    {t('CEOMessage')}
                                </InnerHeading>
                                <SpanStyledB className='d-flex mb-3 transformTxt'>
                                    {i18n.language === "ar" ? 
                                        <>
                                            <span>{t('CEOText')}&nbsp;<SpanStyled className='engReg' color='var(--text2)'>{t('2030')}</SpanStyled>{t('CEOText2')}</span>
                                        </>
                                    : 
                                        <>
                                            {t('CEOText')}
                                        </>
                                    }
                                    
                                </SpanStyledB>
                                
                                
                            </Box>
                            

                        </Col>
                        
                    </Row>
                </Container>
            </TransformWapper>
        </>
    )
}
const TransformWapper = styled.section`
    padding-bottom: 0;
    padding-top: 0;
    background-image: url(${CEOBg});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    
    & > .container{
        .transformRow{
            margin-left: 0;
            margin-right: 0;
        }
        .transformColMain{
            position: relative;
            display: flex;
            align-items: center;
            height: 395px;
            padding-left: 650px;
            
            .transformContent{
                display: flex;
                width: 545px;
                flex-wrap: wrap;
                flex-direction: column;
                padding-left: 0;
                
            }
            .ceoImg{
                position: absolute;
                left: 130px;
                bottom: 0px;
            }
        }
        
    }
    body.rtl &{
        & > .container{
            /* .transformRow{
                margin-left: 0;
                margin-right: 0;
            } */
            .transformColMain{
                padding-left: calc(var(--bs-gutter-x) * .5);
                padding-right: 650px;
                
                .transformContent{
                    width: 545px;
                    /* padding-left: 0;
                    padding-right: 0; */
                    
                }
                .ceoImg{
                    position: absolute;
                    left: auto;
                    right: 130px;
                }
            }
            
        }
    }
    
    @media (max-width: 1399px) {
        
    }
    @media (max-width: 1299px) {
        & > .container{
            .transformColMain{
                padding-left: 550px;
                .transformContent{
                    /* width: 545px; */
                }
                .ceoImg{
                    left: 0;
                }
            }
            
        }
        body.rtl &{
            & > .container{
                .transformColMain{
                    padding-right: 550px;
                    
                    .ceoImg{
                        right: 0;
                    }
                }
                
            }
        }
        
    }
    @media (max-width: 1199px) {
        & > .container{
            .transformColMain{
                padding-left: 500px;
                .transformContent{
                    width: 450px;
                }
                .ceoImg{
                    left: 0;
                }
            }
            
        }
        body.rtl &{
            
        }
    }
    @media (max-width: 991px) {
        & > .container{
            .transformColMain{
                padding: 440px 0 70px 0;
                height: auto;
                .transformContent{
                    width: 100%;
                    padding: 0px 20px 0 20px;
                }
                .ceoImg{
                    /* display: none; */
                    top: -80px;
                    right: 0;
                    left: 0;
                    margin: auto;
                    bottom: unset;
                    width: 450px;
                    
                }
            }
            
        }
        body.rtl &{
            & > .container{
                .transformColMain{
                    padding: 440px 0 70px 0;
                    .transformContent{
                        width: 100%;
                        padding: 0px 20px 0 20px;
                    }
                    .ceoImg{
                        /* display: none; */
                        top: -80px;
                         right: 0;
                        left: 0;
                        margin: auto;
                        bottom: unset;
                    }
                }
                
            }
        }
    }
    @media (max-width: 767px) {
        & > .container{
            .transformColMain{
                padding: 300px 0 70px 0;
                /* height: auto;
                padding-top: 50px !important;
                padding-bottom: 50px !important; */
                .transformContent{
                    width: 100%;
                    padding-left: 5px;
                    padding-right: 5px;
                    .transformTxt{
                        font-size: 18px;
                    }
                }
                .ceoImg{
                    /* width: 100%; */
                    width: 320px;
                    
                }
                
            }
            
        }
        body.rtl &{
            & > .container{
                .transformColMain{
                    padding: 300px 0 70px 0;
                    .transformContent{
                        padding-left: 5px;
                        padding-right: 5px;
                    }
                    
                }
                
            }
        }
    }
    @media (max-width: 640px) {
       
    }
    @media (max-width: 575px) {
        
    }
    @media (max-width: 370px) {
        & > .container{
            .transformColMain{
                padding: 260px 0 70px 0;
                .ceoImg{
                    width: 290px;
                    
                }
                
            }
            
        }
        body.rtl &{
            & > .container{
                .transformColMain{
                    padding: 260px 0 70px 0;
                    
                    
                }
                
            }
        }
    }
`
export default CeoMessage
